<template>
    <div id="services-introduction">
        <div class="content-container">
            <div class="content-inner">
                <div class="subtitle-wrapper">
                    <div class="subtitle title headline-l" v-html="$t('homeScreen.blockChain.header')" />
                </div>
                <div class="container h-100">
                    <div class="row flex-sm-row align-items-center h-100">
                        <div class="col-md-7 col-lg-6 col-12 col-sm-12">
                            <h1 class="title headline-l" v-html="$t('ourServicesScreen.introduction.title')"></h1>
                            <div>
                                <base-button class="launch-button"
                                    :text="$t('ourServicesScreen.introduction.buttonText')" size="large"
                                    type="light-green" @clicked="handleClick" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="introduction-image-wrapper container">
                    <div class="introduction-image d-md-block" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServicesIntroduction',
    props: {},
    components: {},
    data: () => ({}),
    created() { },
    computed: {},
    methods: {
        handleClick() {
            this.$emit('buttonClicked');
        },
    },
};
</script>

<style lang="scss" scoped>
#services-introduction {
    min-height: 675px;
    display: flex;
    border-bottom: 1px solid #4b2eaa80;
    background-image: url('/images/elements/home/web/home_background.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    flex-direction: column;
    background-color: $black;

    @media (max-width: $breakpoint-lg) {
        background-position-x: 70%;
    }

    @media (max-width: $breakpoint-sm) {
        background-image: url('/images/elements/home/mobile/home_background.png');
        background-position-x: center;
    }

    .container {
        z-index: 2;

        @media (min-width: $breakpoint-lg) {
            max-width: 1196px;
        }

        .title {
            color: $white;
            margin-bottom: $margin-m;
            text-transform: uppercase;

            @media (max-width: $breakpoint-sm) {
                text-align: center;
                font-size: 28px;
                line-height: 34px;
            }

            @media (max-width: $breakpoint-xs) {
                text-align: center;
                font-size: 28px;
                line-height: 34px;
            }

            @media (min-width: $breakpoint-lg) {
                max-width: 540px;
            }
        }
    }

    .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 675px;

        @media (max-width: $breakpoint-sm) {
            height: 100%;
            background: linear-gradient(rgba(4, 4, 40, 1),
                    rgba(21, 26, 192, 0),
                    rgba(13, 13, 95, 1),
                    rgba(4, 4, 40, 1),
                    rgba(4, 4, 40, 1),
                );
        }

        .content-inner {
            width: 100%;
            display: flex;
            height: 100%;
            flex-direction: column;
            align-items: center;
            z-index: 1;

            @media (max-width: $breakpoint-md) {
                margin-top: auto;
                margin-bottom: 40px;
            }
        }
    }

    .introduction-image-wrapper {
        position: absolute;
        justify-content: end;
        display: flex;
        margin-top: auto;
        top: 0px;
        height: 675px;
        z-index: 1;

        @media (max-width: $breakpoint-lg) {
            right: 15px;
        }

        @media (max-width: $breakpoint-md) {
            right: 15px;
        }

        @media (max-width: $breakpoint-sm) {
            position: absolute;
            justify-content: center;
            margin-top: 0px;
            // height: 396px;
            // min-height: 396px;
            // top: 78px;
            z-index: 1;
            right: unset;
            max-width: 100%;
            height: 675px;
            // padding-right: 0px;
        }
    }

    .introduction-image {
        height: 594px;
        object-fit: contain;
        margin-top: auto;
        margin-bottom: auto;
        width: 100%;
        top: 72px;
        background: url('/images/elements/home/web/services-introduction-app-illustration.png') no-repeat bottom right;
        background-size: contain;

        @media (max-width: $breakpoint-lg) {
            height: 500px;
        }

        @media (max-width: $breakpoint-sm) {
            margin-top: 72px;
            height: 396px;
            background: url('/images/elements/home/web/services-introduction-app-illustration.png') no-repeat center center;
            background-size: contain;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                height: 675px;
                background: linear-gradient(rgba(21, 26, 192, 0),
                        rgba(21, 26, 192, 0),
                        rgba(15, 15, 116, 0),
                        rgba(15, 15, 116, 0.1),
                        rgba(15, 15, 116, 0.3),
                        rgba(15, 15, 116, 0.5),
                        rgba(4, 4, 40, 1.0),
                        rgba(4, 4, 40, 1),
                        rgba(4, 4, 40, 1),
                        rgba(4, 4, 40, 1), );
                pointer-events: none;
            }
        }
    }
}

@media (max-width: $breakpoint-sm) {
    #services-introduction {
        min-height: unset !important;

        .title {
            margin-bottom: 18px !important;
        }
    }
}

.launch-button {
    text-transform: uppercase;

    @media (max-width: $breakpoint-sm) {
        width: 100%;
    }
}

.subtitle {
    color: $white !important;
    border-radius: 4px;
    display: inline-block;
    font-family: 'HKNova-SemiBold', sans-serif;

    @media (max-width: $breakpoint-sm) {
        display: block;
        text-align: center;
        margin-left: 0;
        padding-left: 16px;
    }
}

.subtitle-wrapper {
    padding-left: calc(((100vw - 1196px) / 2) + 15px);
    display: flex;
    position: relative;
    background: linear-gradient(94.24deg, #080A5B 0%, #2F2FD1 100%);
    width: fit-content;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 20px;
    margin-right: auto;
    margin-bottom: 52px;
    z-index: 2;

    @media (max-width: $breakpoint-lg) {
        padding-left: calc(((100vw - 960px) / 2) + 15px);
    }

    @media (max-width: $breakpoint-md) {
        padding-left: calc(((100vw - 720px) / 2) + 15px);
    }

    @media (max-width: $breakpoint-sm) {
        z-index: 0;
        top: 0;
        position: absolute;
        width: 100%;
        justify-content: center;
        padding-top: 34px;
        padding-bottom: 24px;
        padding-right: 0px;
        padding-left: 0px;
    }

    .title {
        color: $white;
        text-transform: uppercase;

        @media (max-width: $breakpoint-sm) {
            text-align: center;
            font-size: 28px;
            line-height: 34px;
        }

        @media (max-width: $breakpoint-xs) {
            text-align: center;
            font-size: 28px;
            line-height: 34px;
        }

        @media (min-width: $breakpoint-lg) {
            max-width: 540px;
        }
    }
}
</style>
